import { Controller, FetchOptions, Result } from 'bernie-core';
import '../client/temp-common-imports';
import { withSecurity } from '../components/auth';
import { Signout } from 'components/signin/signout';

export class SignoutController implements Controller {
  public routeName = 'signout';
  public pageId = 'pages.signout';
  public path = '/signout';
  public exact = true;
  public bundles = [];

  /**
   * Components may be referred to directly
   *   `public component = ExamplePage;`
   *
   * Or, the preferred option is to create a code split point that will generate a new bundle.
   *   Use webpacks magic comments `webpackChunkName: "INSERT_FRIENDLY_NAME_HERE"`
   *   This will give it a friendly name for the name of the file.
   */
  public component = withSecurity(Signout, this.path);

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    return Promise.resolve(Result.ok());
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData() {
    return Promise.resolve({ title: 'Affiliate Hub Sign-out' });
  }
}
